import '../sass/project.scss'; // TODO: explicitly add entry point to webpack??

import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';

import NormairApp from './react/norm_air/App';
import ReduCO2App from './react/reduco2/App';
import KnowledgeBase from './react/KnowledgeBase';
import AteApp from './react/ate/App';
import Srodek from './react/srodek/App';
import Ite from './react/ite/App';
import TaskModal from './react/TaskModal';
import AccountDeleteModal from './react/AccountDeleteModal';
import { ProjectApi, StepsApi } from './react/norm_air/APIs';

// Norm-AIR needs yet to be converted to Axios for now using mainly for ATE
axios.defaults.withCredentials = true;
axios.defaults.xsrfCookieName = window.CSRF_COOKIE_NAME;
axios.defaults.xsrfHeaderName = 'X-Csrftoken';

function renderReactApp() {
  const modalRoot = document.getElementById('modal-root');
  if (modalRoot) {
    ReactDOM.createRoot(modalRoot).render(
      <TaskModal backendUrl={modalRoot.dataset.backendUrl} />,
    );
  }

  const acountDeleteModalRoot = document.getElementById(
    'dlt-account-modal-root',
  );
  if (acountDeleteModalRoot) {
    ReactDOM.createRoot(acountDeleteModalRoot).render(<AccountDeleteModal />);
  }

  const applicationRoot = document.getElementById('app-root');
  if (applicationRoot) {
    const appInfo = window.appInfo;

    if (appInfo.type == 'reduco2') {
      ReactDOM.createRoot(applicationRoot).render(
        <ReduCO2App
          submitUrl={DjUrls['reduco2:calculate']()}
          csrfToken={appInfo.csrfToken}
          maxTasks={appInfo.maxTasksPerUser}
        />,
      );
    } else if (appInfo.type == 'norm-air') {
      ReactDOM.createRoot(applicationRoot).render(
        <NormairApp
          APIs={{
            // DjUrls are provided by the dj-js-reverse package
            projects: new ProjectApi(DjUrls, appInfo.csrfToken),
            steps: new StepsApi(DjUrls, appInfo.csrfToken),
          }}
          estimatedTimes={appInfo.estimatedTimes}
          taskPollInterval={appInfo.taskPollInterval}
          downloadFiles={{
            dataExample:
              window.StaticURL + 'download/normair_przykladowe_dane.csv',
            manual: undefined,
          }}
        />,
      );
    } else if (appInfo.type == 'ate') {
      ReactDOM.createRoot(applicationRoot).render(
        <AteApp
          data={appInfo.data}
          exampleDataLink={appInfo.exampleDataLink}
          exampleInformationLink={appInfo.exampleInformationLink}
        />,
      );
    } else if (appInfo.type == 'srod+ek') {
      ReactDOM.createRoot(applicationRoot).render(
        // TODO: spread appInfo in other apps
        <Srodek {...appInfo} urls={DjUrls} />,
      );
    } else if (appInfo.type == 'ite') {
      ReactDOM.createRoot(applicationRoot).render(
        <Ite
          internationalRankingYearsAvailable={JSON.parse(
            appInfo.internationalRankingYearsAvailable,
          )}
          csrfToken={appInfo.csrfToken}
          urls={DjUrls}
        />,
      );
    }
  }

  const knowledgeBaseRoot = document.getElementById('knowledgebase-root');
  if (knowledgeBaseRoot) {
    const reports = JSON.parse(document.getElementById('reports').innerText);
    ReactDOM.createRoot(knowledgeBaseRoot).render(
      <KnowledgeBase data={reports} />,
    );
  }
}

renderReactApp();
